// @ts-nocheck
import _ from "lodash";
import { roleInformationInitialValues } from "../../utils/schemas/addContractor/roleInformationInitialValues";
import {
  CONTRACTOR_SIGNUP_STEP1_FAILURE,
  CONTRACTOR_SIGNUP_STEP1_REQUEST,
  CONTRACTOR_SIGNUP_STEP1_SUCCESS,
  CONTRACTOR_SIGNUP_STEP1_UPDATE_FAILURE,
  CONTRACTOR_SIGNUP_STEP1_UPDATE_REQUEST,
  CONTRACTOR_SIGNUP_STEP1_UPDATE_SUCCESS,
  CONTRACTOR_SIGNUP_STEP2_FAILURE,
  CONTRACTOR_SIGNUP_STEP2_REQUEST,
  CONTRACTOR_SIGNUP_STEP2_SUCCESS,
  CONTRACTOR_SIGNUP_STEP3_FAILURE,
  CONTRACTOR_SIGNUP_STEP3_REQUEST,
  CONTRACTOR_SIGNUP_STEP3_SUCCESS,
  CONTRACTOR_SIGNUP_STEP4_FAILURE,
  CONTRACTOR_SIGNUP_STEP4_REQUEST,
  CONTRACTOR_SIGNUP_STEP4_SUCCESS,
  CLEAR_CONTRACTOR_SIGNUP,
  SET_CONTRACTOR_SIGNUP_MULTIPLE_FIELDS,
  CONTRACTOR_SIGNUP_STEP5_REQUEST,
  CONTRACTOR_SIGNUP_STEP5_SUCCESS,
  CONTRACTOR_SIGNUP_STEP5_FAILURE,
  UPDATE_CONTRACTOR_CERTIFICATES_SIGNUP_STEP5,
  ADD_STEP_1_FROM_API_REQUEST,
  ADD_STEP_1_FROM_API_FAILURE,
  ADD_STEP_1_FROM_API_SUCCESS,
} from "../constants/contractorSignup";
import {
  RESEND_SIGNUP_SMS_LINK_REQUEST,
  RESEND_SIGNUP_SMS_LINK_SUCCESS,
} from "../constants/contractor";

const contractorSignupInit = {
  step1: {
    submitFormRequestLoading: false,
    data: null,
    form: null,
    previouslySubmittedForm: null,
  },
  step2: {
    submitFormRequestLoading: false,
    data: null,
    form: null,
    previouslySubmittedForm: null,
  },
  step3: {
    submitFormRequestLoading: false,
    data: null,
    form: null,
    previouslySubmittedForm: null,
  },
  step4: {
    submitFormRequestLoading: false,
    data: null,
    form: null,
    previouslySubmittedForm: null,
  },
  step5: {
    submitFormRequestLoading: false,
    data: null,
    form: null,
    previouslySubmittedForm: null,
  },
  reset: {
    count: null,
  },
};

const initialState = {
  contractorSignup: contractorSignupInit,
  provisional: {
    provisionalLoading: false,
    isCalled: false,
  },
};

const contractorSignupReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_CONTRACTOR_SIGNUP_MULTIPLE_FIELDS:
      return {
        ...state,
        ...action?.payload,
      };

    case CONTRACTOR_SIGNUP_STEP1_REQUEST:
      return {
        ...state,
        contractorSignup: {
          ...state?.contractorSignup,
          step1: {
            ...state?.contractorSignup?.step1,
            submitFormRequestLoading: true,
          },
        },
      };

    case CONTRACTOR_SIGNUP_STEP1_SUCCESS:
      return {
        ...state,
        contractorSignup: {
          ...state?.contractorSignup,
          step1: {
            ...state?.contractorSignup?.step1,
            data: action?.payload?.data,
            submitFormRequestLoading: false,
            form: action?.payload?.formData,
            previouslySubmittedForm: action.payload?.formData,
          },
          step2: {
            ...state?.contractorSignup?.step2,
            form: {
              ...roleInformationInitialValues,
              ...(state?.contractorSignup?.step2?.form || {}),
              roleExperience:
                action?.payload?.data?.roleExperience ||
                state?.contractorSignup?.step2?.form?.roleExperience,
            },
          },
        },
      };

    case CONTRACTOR_SIGNUP_STEP1_FAILURE:
      return {
        ...state,
        contractorSignup: {
          ...state?.contractorSignup,
          step1: {
            ...state?.contractorSignup?.step1,
            submitFormRequestLoading: false,
          },
        },
      };

    case CONTRACTOR_SIGNUP_STEP1_UPDATE_REQUEST:
      return {
        ...state,
        contractorSignup: {
          ...state?.contractorSignup,
          step1: {
            ...state?.contractorSignup?.step1,
            submitFormRequestLoading: true,
          },
        },
      };

    case CONTRACTOR_SIGNUP_STEP1_UPDATE_SUCCESS:
      return {
        ...state,
        contractorSignup: {
          ...state?.contractorSignup,
          step1: {
            ...state?.contractorSignup?.step1,
            data: {
              ...state?.contractorSignup?.step1?.data,
              ...action?.payload?.data,
            },
            submitFormRequestLoading: false,
            form: action?.payload?.formData,
            previouslySubmittedForm: action.payload?.formData,
          },
        },
      };

    case CONTRACTOR_SIGNUP_STEP1_UPDATE_FAILURE:
      return {
        ...state,
        contractorSignup: {
          ...state?.contractorSignup,
          step1: {
            ...state?.contractorSignup?.step1,
            submitFormRequestLoading: false,
          },
        },
      };

    case CONTRACTOR_SIGNUP_STEP2_REQUEST:
      return {
        ...state,
        contractorSignup: {
          ...state?.contractorSignup,
          step2: {
            ...state?.contractorSignup?.step2,
            submitFormRequestLoading: true,
          },
        },
      };

    case CONTRACTOR_SIGNUP_STEP2_SUCCESS:
      return {
        ...state,
        contractorSignup: {
          ...state?.contractorSignup,
          step2: {
            ...state?.contractorSignup?.step2,
            data: action?.payload?.data,
            submitFormRequestLoading: false,
            form: action?.payload?.formData,
            previouslySubmittedForm: action.payload?.formData,
          },
        },
      };

    case CONTRACTOR_SIGNUP_STEP2_FAILURE:
      return {
        ...state,
        contractorSignup: {
          ...state?.contractorSignup,
          step2: {
            ...state?.contractorSignup?.step2,
            submitFormRequestLoading: false,
          },
        },
      };

    case CONTRACTOR_SIGNUP_STEP3_REQUEST:
      return {
        ...state,
        contractorSignup: {
          ...state?.contractorSignup,
          step3: {
            ...state?.contractorSignup?.step3,
            submitFormRequestLoading: true,
          },
        },
      };

    case CONTRACTOR_SIGNUP_STEP3_SUCCESS:
      return {
        ...state,
        contractorSignup: {
          ...state?.contractorSignup,
          step3: {
            ...state?.contractorSignup?.step3,
            data: action?.payload?.data,
            submitFormRequestLoading: false,
            form: action?.payload?.formData,
            previouslySubmittedForm: action.payload?.formData,
          },
        },
      };

    case CONTRACTOR_SIGNUP_STEP3_FAILURE:
      return {
        ...state,
        contractorSignup: {
          ...state?.contractorSignup,
          step3: {
            ...state?.contractorSignup?.step3,
            submitFormRequestLoading: false,
          },
        },
      };

    case CONTRACTOR_SIGNUP_STEP4_REQUEST:
      return {
        ...state,
        contractorSignup: {
          ...state?.contractorSignup,
          step4: {
            ...state?.contractorSignup?.step4,
            submitFormRequestLoading: true,
          },
        },
      };

    case CONTRACTOR_SIGNUP_STEP4_SUCCESS:
      return {
        ...state,
        contractorSignup: {
          ...state?.contractorSignup,
          step4: {
            ...state?.contractorSignup?.step4,
            data: action?.payload?.data,
            submitFormRequestLoading: false,
            form: action?.payload?.formData,
            previouslySubmittedForm: action.payload?.formData,
          },
        },
      };

    case CONTRACTOR_SIGNUP_STEP4_FAILURE:
      return {
        ...state,
        contractorSignup: {
          ...state?.contractorSignup,
          step4: {
            ...state?.contractorSignup?.step4,
            submitFormRequestLoading: false,
          },
        },
      };

    case CONTRACTOR_SIGNUP_STEP5_REQUEST:
      return {
        ...state,
        contractorSignup: {
          ...state?.contractorSignup,
          step5: {
            ...state?.contractorSignup?.step5,
            submitFormRequestLoading: true,
          },
        },
      };

    case CONTRACTOR_SIGNUP_STEP5_SUCCESS:
      return {
        ...state,
        contractorSignup: {
          ...state?.contractorSignup,
          step5: {
            ...state?.contractorSignup?.step5,
            data: action?.payload?.data,
            submitFormRequestLoading: false,
            form: action?.payload?.formData,
            previouslySubmittedForm: action.payload?.formData,
          },
        },
      };

    case CONTRACTOR_SIGNUP_STEP5_FAILURE:
      return {
        ...state,
        contractorSignup: {
          ...state?.contractorSignup,
          step5: {
            ...state?.contractorSignup?.step5,
            submitFormRequestLoading: false,
          },
        },
      };

    case UPDATE_CONTRACTOR_CERTIFICATES_SIGNUP_STEP5:
      return {
        ...state,
        contractorSignup: {
          ...state?.contractorSignup,
          step5: {
            ...state?.contractorSignup?.step5,
            data: {
              ...state?.contractorSignup?.step5?.data,
              certifications: action?.payload?.certifications,
            },
          },
        },
      };

    case CLEAR_CONTRACTOR_SIGNUP:
      return {
        ...state,
        contractorSignup: {
          ...contractorSignupInit,
          reset: {
            ...state?.contractorSignup?.reset,
            count:
              typeof state?.contractorSignup?.reset?.count === "number"
                ? (state?.contractorSignup?.reset?.count + 1) % 10
                : 0,
          },
        },
      };

    // set provisional data on form 1
    case ADD_STEP_1_FROM_API_REQUEST: {
      return {
        ...state,
        provisional: {
          provisionalLoading: true,
        },
      };
    }

    case ADD_STEP_1_FROM_API_FAILURE: {
      return {
        ...state,
        provisional: {
          provisionalLoading: false,
          isCalled: true,
        },
      };
    }

    case ADD_STEP_1_FROM_API_SUCCESS: {
      // const form1Data = _.cloneDeep(action?.payload?.data);
      // delete form1Data?._id;

      return {
        ...state,
        // step1: {
        //   ...state?.step1,
        //   form: {
        //     ...form1Data,
        //   },
        // },
        provisional: {
          provisionalLoading: false,
          isCalled: true,
        },
      };
    }

    default:
      return state;
  }
};

export { contractorSignupReducer, initialState };